import React, { useEffect, useState, useContext } from 'react';
import axiosInstance from '../../../../services/AxiosInstance';
import InputField from '../../../../components/InputField';
import { userContext } from '../../../../contextProvider/Authentication';
import swal from 'sweetalert';

function OnlinePresence({ stud_id }) {

    const [input, setInput] = useState();
    const { user } = useContext(userContext);

    const label = [
        { name: "linkedin", label: "Linkedin" },
        { name: "facebook", label: "Facebook" },
        { name: "twitter", label: "Twitter" },
        { name: "github", label: "GitHub" },
        { name: "stackoverflow", label: "Stackoverflow" },
        { name: "website", label: "Personal Website" },
    ]

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = () => {
        var url = stud_id ? `can-online-presence/?candidate=${stud_id}` : "can-online-presence/";
        axiosInstance(
            url, {
            method: "GET",
            data: {}
        }).then(res => {
            setInput(res?.data?.results?.[0]);
        }).catch(err => {
            swal("", Object.values(err.response.data), "error", { button: "Ok!", });
        })
    }

    const handleChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value });
    }

    const handleSubmit = () => {
        input["candidate"] = stud_id ?? user?.id;
        var url = input?.id ? `can-online-presence/${input.id}/` : "can-online-presence/";
        var method = input?.id ? `PUT` : "POST";

        axiosInstance(
            url, {
            method: method,
            data: input
        }).then(res => {
            if (res?.status === 201 || res?.status === 200) {
                swal("", "Succesfully saved", "success", { button: "Ok!", });
                getData();
            }
        }).catch(err => {
            swal("", Object.values(err.response.data), "error", { button: "Ok!", });
        });
    }

    return (
        <div id="it_skills_bx" className="job-bx table-job-bx bg-white m-b30">
            <div className="d-flex">
                <h5 className="m-b15">Online Presence</h5>
            </div>
            {
                label.map(res => {
                    var name = res?.name;
                    return (
                        <div className="row mb-3" key={name}>
                            <div className="col-12 col-md-3">
                                <label className="mt-2">{res?.label}</label>
                            </div>
                            <div className="col-12 col-md-7">
                                <InputField
                                    name={name}
                                    value={input?.[name]}
                                    onChange={(e) => handleChange(e)}
                                    required={false}
                                    placeholder={`Enter ${name}`}
                                />
                            </div>
                        </div>
                    )
                })
            }
            <button
                type="button"
                className="site-button"
                onClick={() => handleSubmit()}
                disabled={!input ? true : false}
                style={{ backgroundColor: input ? "#1d46f5" : "#8b99d5", cursor: input ? "pointer" : "not-allowed" }}
            >
                Save
            </button>
        </div>
    );
}

export default OnlinePresence;